/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-extra-boolean-cast */
/* eslint-disable react-native/no-inline-styles */
import React, { useState } from 'react';
import { FlatList, useWindowDimensions, View } from 'react-native';
import { Divider, List, MD2Colors, Switch } from 'react-native-paper';
import { useDispatch } from 'react-redux';
import Item from './Item';
import { hideLoader, showLoader } from '../../store/info.slice';
import { doPut } from '../../services/http';
import { errorHandler, prepareDataForFlatList } from '../../services/Utils';

const getNumColumns = (width) => {
    if (width < 500) { return 1; }
    if (width < 576) { return 2; }
    if (width < 768) { return 2; }
    if (width < 992) { return 3; }
    if (width < 1200) { return 4; }
    if (width < 1400) { return 5; }
    return 5;
};

function CategoryItems({ category, searchQuery, _items, counter, onUpdateCategoryStatus, onUpdateItemStatus, onUpdateItemStockQty }) {
    const prevent_item_status_update_on_category_status_change = counter?.settings?.prevent_item_status_update_on_category_status_change || false;
    const dispatch = useDispatch();
    const { width } = useWindowDimensions();
    const numColumns = getNumColumns(width);
    let items = prepareDataForFlatList({
        numColumns,
        key: 'item_id',
        page: 1,
        data: _items.filter(item => item?.category_id === category?.category_id),
    });
    if (!!searchQuery) {
        items = items.filter(item => !item?.isEmpty && (item.item_name).toLowerCase().includes(searchQuery.toLowerCase()));
    }
    const handlePress = () => {
        onToggleSwitch();
    };

    const [isSwitchOn, setIsSwitchOn] = useState(category?.category_status);
    const onToggleSwitch = () => {
        dispatch(showLoader());
        doPut('category', { canteen_id: category?.canteen_id, category_id: category.category_id, category_status: !isSwitchOn, prevent_item_status_update_on_category_status_change }).then(response => {
            dispatch(hideLoader());
            setIsSwitchOn(!isSwitchOn);
            if (onUpdateCategoryStatus) {
                onUpdateCategoryStatus({ canteen_id: category?.canteen_id, category_id: category.category_id, category_status: !isSwitchOn, prevent_item_status_update_on_category_status_change });
            }
        }).catch(error => {
            // setExpanded(expanded);
            setIsSwitchOn(isSwitchOn);
            errorHandler(error);
        });
    };

    const renderItem = ({ item }) => {
        if (item.isEmpty) {
            return <View style={{ flex: 1 }} />;
        }
        return (
            <View style={{ flex: 1, marginHorizontal: 1, marginVertical: 0 }}>
                <Item category={category} onUpdateItemStatus={onUpdateItemStatus} onUpdateItemStockQty={onUpdateItemStockQty} counter={counter} item={item} />
            </View>
        );
    };


    return (
        <React.Fragment>
            {items.length > 0 && <View style={{ marginBottom: 0 }}>
                <List.Item
                    title={category?.category_name}
                    titleStyle={{ fontSize: 14, color: '#000' }}
                    style={{ backgroundColor: MD2Colors.grey300, paddingVertical: 4 }}
                    right={props => <Switch {...props} color={MD2Colors.green900} value={isSwitchOn} onValueChange={() => handlePress()} />}
                />
                <FlatList
                    data={items}
                    renderItem={renderItem}
                    ListHeaderComponent={<Divider theme={{ colors: { outlineVariant: '#e7e7e7' } }} />}
                    ItemSeparatorComponent={<Divider theme={{ colors: { outlineVariant: '#e7e7e7' } }} />}
                    keyExtractor={(item) => (item?.item_id).toString()}
                    key={numColumns}
                    numColumns={numColumns}
                    columnWrapperStyle={numColumns > 1 ? { gap: 0.5 } : undefined} // RN 0.71+
                />
            </View>
            }
        </React.Fragment>
    );
}

export default CategoryItems;
